import React, { Component } from 'react';
import BootstrapTable2 from 'react-bootstrap-table-next';

class NaptarModule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      esemenytipusokTooltips: [],
    };

    this.options = {
      // 1 blockon belül hány belső tagolással elválasztott mini-block legyen
      tordeles: this.props.JSON.tordelesszam,
    };
  }

  componentDidMount() {
    this.createTooltips();
  }

  createColumns = () => {
    let columns = [];
    columns.push({
      dataField: '',
      text: '',
      formatter: this.leftColumnFormatter,
      formatExtraData: this.props.JSON.blocknevek,
      attrs: this.leftColumnAttributes,
      align: 'center',
      headerStyle: this.leftColumnStyleHeader,
      style: this.leftColumnCellStyle
    });
    for (let i = 0; i < this.props.JSON.oszlopnevek.length; i++) {
      columns.push({
        dataField: 'oszlopok[' + i + ']',
        text: this.props.JSON.oszlopnevek[i],
        formatter: this.formatter,
        headerFormatter: this.headerFormatter,
        headerStyle: this.headerStyle,
        style: this.columnCellStyle,
        attrs: this.columnAttributes,
        title: this.getTooltipString,
        events: {
          onClick: this.onClick
        },
        headerAlign: 'center'
      });
    }
    this.columns = columns;
  }

  headerFormatter = (column) => {
    let { text } = column;
    let dividerIndex = text.indexOf('|');
    return (
      <div>
        {text.slice(0, dividerIndex)}
        <br />
        {text.slice(dividerIndex + 1)}
      </div>
    );
  }

  headerStyle = () => {
    return { borderBottomWidth: '1px' };
  }

  // Így nem fog a cellában semmi sem látszódni
  formatter = () => {}

  createTooltips = () => {
    let esemenytipusokTooltips = this.props.esemenytipusok.map(esemenytipus => (
      <div className="row col-auto" style={{ margin: '0px 10px' }}>
        <div style={{
          height: '10px', width: '10px', backgroundColor: '#' + esemenytipus.szinkod, margin: 'auto 5px', padding: 0
        }}
        />
        {esemenytipus.nev}
      </div>
    ));
    this.setState({ esemenytipusokTooltips });
  }

  leftColumnFormatter = (cell, row, rowIndex, formatExtraData) => {
    const {
      blockmeret
    } = this.props.JSON;
    return formatExtraData[rowIndex / blockmeret];
  }

  leftColumnCellStyle = () => {
    return { verticalAlign: 'middle', padding: 0 };
  }

  leftColumnStyleHeader = () => {
    return { width: '50px', borderBottom: '1px' };
  }

  leftColumnAttributes = (cell, row, rowIndex) => {
    const {
      blockmeret
    } = this.props.JSON;
    if (rowIndex % blockmeret == 0) return { rowspan: blockmeret };
    return { hidden: true };
  }

  columnCellStyle = (cell, row, rowIndex, columnIndex) => {
    let border = '2px solid black';
    let styleObj = {
      padding: 0,
      height: '10px',
      backgroundColor: cell.esemenytipus ? '#' + this.props.esemenytipusok.find(esemenytipus => esemenytipus.id === cell.esemenytipus.id).szinkod : '#ffffff',
      borderTop: 0
    };
    // Adott block nem-utolsó celláinak alsó border-ének törlése
    if ((rowIndex + 1) % (this.props.JSON.blockmeret / this.options.tordeles) != 0) { styleObj.borderBottom = 0; }
    // Szélső border rárakása azon cellákra amikre időpont létezik
    if (cell.id) {
      styleObj.borderLeft = border;
      styleObj.borderRight = border;
    }
    if (rowIndex < this.props.JSON.sorok.length - 1) {
      // Legfelső cella felső border-e
      if (cell.id && rowIndex == 0) {
        styleObj.borderTop = border;
      }

      let cellNext = this.props.JSON.sorok[rowIndex + 1].oszlopok[columnIndex - 1];
      // Különböző típusok és cellák közé border
      if (cell.id != cellNext.id || (cell.esemenytipus && cellNext.esemenytipus && cell.esemenytipus.id != cellNext.esemenytipus.id)) {
        styleObj.borderBottom = border;
        // Kilépés, ebben az esetben sosem fut meg az utolsó if
        return styleObj;
      }
    }
    // Legalsó cella alsó border-e
    if (cell.id && this.props.JSON.sorok.length - 1 == rowIndex) { styleObj.borderBottom = border; }
    return styleObj;
  }

  columnAttributes = (cell, row, rowIndex) => {
    const {
      blockmeret
    } = this.props.JSON;
    if ((rowIndex + 1) % blockmeret != 0 && this.emptyBlocks.includes(Math.floor(rowIndex / blockmeret))) {
      return { hidden: true };
    }
  }

  getTooltipString = (cell) => {
    if (cell.esemenytipus) {
      return this.props.JSON.naptartooltipinfo[cell.id];
    }
    return '';
  }

  findEmptyBlocks = () => {
    const {
      sorok,
      blockmeret
    } = this.props.JSON;
    let emptyBlocks = [];
    for (let i = 0; i < sorok.length; i++) {
      const sor = sorok[i];
      let empty = true;
      for (let o = 0; o < sor.oszlopok.length; o++) {
        const oszlop = sor.oszlopok[o];
        if (oszlop.id != null) {
          // Ha talált olyan cellát ami nem az alapértelmezett üres állapotban van, akkor a block már nem üres
          empty = false;
          // Sor számláló átugratása az utolsó cellára (felesleges lenne egyesével elszámolni odáig)
          i += blockmeret - ((i % blockmeret) + 1);
          break;
        }
      }
      if (empty) {
        emptyBlocks.push(((i + 1) / blockmeret) - 1);
      }
    }
    this.emptyBlocks = emptyBlocks;
  }

  onClick = (event, column, columnIndex, row, rowIndex) => {
    const {
      handleSzabadClick,
      handleEmptyClick,
    } = this.props;
    const {
      blockmeret,
      blocknevek,
      cellameret,
      oszlopidok,
    } = this.props.JSON;
    // Az bal szélső oszlop miatt vissza kell állítani az indexet
    columnIndex--;

    const cell = row.oszlopok[columnIndex];
    let time = new Date();
    let blockIndex = Math.floor(rowIndex / blockmeret);
    let timeString = blocknevek[blockIndex];
    let dividerIndex = timeString.indexOf(':');
    let hour = timeString.slice(0, dividerIndex);
    let minute = timeString.slice(dividerIndex + 1);
    // Ha a block utolsó cellája volt kattintva, és ez egy üres block (az üres block mindig az utolsó cellát mutatja),
    // akkor nem kell a percet növelni
    if (!this.emptyBlocks.includes(Math.floor(((rowIndex + 1) / blockmeret) - 1))) {
      let cellOffset = (rowIndex % blockmeret) * cellameret;
      if (cellOffset > 60) {
        hour += cellOffset % 60;
      }
      minute += cellOffset;
    }
    time.setHours(hour);
    time.setMinutes(minute);
    time.setSeconds(0);

    let oszlopido = oszlopidok[columnIndex];
    let date = new Date(oszlopido);

    let obj = {
      date, kezdet: time, vege: time
    };

    obj.id = cell.id;
    if (cell.esemenytipus) {
      handleSzabadClick(obj);
    } else {
      handleEmptyClick(obj);
    }
  }

  renderColoredBox = (color) => {
    return (
      <div style={{
        height: '10px', width: '10px', backgroundColor: color, margin: 'auto 5px'
      }}
      />
    );
  }

  renderTooltip = () => {
    return (
      <div className="row no-gutters float-right" style={{ display: 'flex', alignItems: 'center', margin: '0px 10px 10px 0px' }}>
        {this.state.esemenytipusokTooltips}
      </div>
    );
  }

  renderTable = () => {
    if (!this.columns) { this.createColumns(); }
    if (!this.emptyBlocks) { this.findEmptyBlocks(); }
    return (
      <BootstrapTable2
        bootstrap4
        keyField="id"
        data={this.props.JSON.sorok}
        columns={this.columns}
      />
    );
  }

  render() {
    return (
      <div>
        <div>
          {this.renderTooltip()}
        </div>
        <div style={{ marginTop: '-20px' }}>
          {this.renderTable()}
        </div>
      </div>
    );
  }
}

export default NaptarModule;
